module.exports = __webpack_public_path__ + "static/media/snare.5e114c2d.ogg";